module.exports = __webpack_public_path__ + "static/media/witchCompanion.6994e797.jpg";